import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/Button.js';
import { Modal } from '../ui/Modal.js';
import { ContactSelector, type ContactSelectorValue } from '../ui/ContactSelector.js';

interface Props {
  count: number;
  loading: boolean;
  onClose: () => void;
  onConfirm: (contactId: number) => void;
}

export function LinkToContactModal({ count, loading, onClose, onConfirm }: Props) {
  const { t } = useTranslation();
  const [contact, setContact] = useState<ContactSelectorValue | null>(null);

  return (
    <Modal
      open
      onClose={onClose}
      title={t('dmTriage.linkModal.title')}
      description={t('dmTriage.linkModal.description', { count })}
      size="sm"
      preventClose={loading}
      footer={
        <>
          <Button variant="outline" tone="muted" onClick={onClose} disabled={loading}>
            {t('common.cancel')}
          </Button>
          <Button
            variant="solid"
            tone="cyan"
            disabled={!contact || loading}
            loading={loading}
            onClick={() => contact && onConfirm(contact.id)}
          >
            {t('dmTriage.linkModal.confirm')}
          </Button>
        </>
      }
    >
      <ContactSelector
        value={contact}
        onChange={setContact}
        disabled={loading}
        placeholder={t('dmTriage.linkModal.searchPlaceholder')}
        fullWidth
      />
    </Modal>
  );
}
